<canvas #pdfCanvas style="display: block;"></canvas>